module.exports = __webpack_public_path__ + "cafe39cf979e004577908092f7ea16d9.jpg";